const CustomerAccount = {
  tabs: ['dashboard', 'orders', 'profile', 'addresses'],
  basePath: '/account',

  init() {
    this.initElements();
    this.bindEvents();
    this.routeFromPath();
  },

  initElements() {
    this.tabLinks = document.querySelectorAll('.tab-link');
    this.tabContents = document.querySelectorAll('.tab-content');
  },

  bindEvents() {
    this.tabLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const tab = link.getAttribute('data-tab');
        this.switchTab(tab);
        this.updatePath(tab);
      });
    });
    const viewOrdersCTA = document.querySelector('[data-action="view-orders"]');
    if (viewOrdersCTA) {
      viewOrdersCTA.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab('orders');
        this.updatePath('orders');
      });
    }
  },

  routeFromPath() {
    const currentPath = window.location.pathname
      .replace(this.basePath, '')
      .replace(/^\/+/, '');
    const tab = this.tabs.includes(currentPath) ? currentPath : 'dashboard';
    this.switchTab(tab);
  },

  switchTab(tab) {
    // Hide all tab content
    this.tabContents.forEach((el) => el.classList.add('hidden'));
    this.tabLinks.forEach((el) =>
      el.classList.remove(
        'lg:underline',
        'border-b-2',
        'lg:border-0',
        'font-medium',
      ),
    );

    // Show selected tab
    const content = document.querySelector(`[data-tab-content="${tab}"]`);
    const link = document.querySelector(`[data-tab="${tab}"]`);
    if (content && link) {
      content.classList.remove('hidden');
      link.classList.add(
        'lg:underline',
        'border-b-2',
        'lg:border-0',
        'font-medium',
      );
    }

    // Fetch tab data
    this.loadTabData(tab);
  },

  updatePath(tab) {
    const newPath =
      tab === 'dashboard' ? this.basePath : `${this.basePath}/${tab}`;
    history.replaceState(null, '', newPath);
  },

  async loadTabData(tab) {
    switch (tab) {
      case 'orders':
        await this.fetchOrders();
        break;
      case 'profile':
        await this.fetchProfile();
        break;
      case 'addresses':
        await this.fetchAddresses();
        break;
      case 'dashboard':
      default:
        // Optionally fetch dashboard data
        break;
    }
  },

  async fetchOrders() {
    // Replace with your Storefront API call
    console.log('Fetching Orders...');
    // Example:
    // const res = await fetch('/account/orders.json');
    // const data = await res.json();
    // Render it here
  },

  async fetchProfile() {
    console.log('Fetching Profile...');
    // Fetch profile data via Storefront API
  },

  async fetchAddresses() {
    console.log('Fetching Addresses...');
    // Fetch address data via Storefront API
  },
};

export default CustomerAccount;
